import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root&>div": {
      // paddingTop: 5,
      // paddingBottom: 0,
    },
  },
  input: {
    height: 86,
  },
  textarea: {
    height: 130,
  },
  textAreaInput: {
    // !important needed because of https://github.com/visualization-suite/hvs_web/commit/755c0bf101b78b9038c75bfa23598ad6cc32d894#diff-61c28cd2cfcfd2fca70d1e3b7fcf909dd0bb7c1b3fe1c3cdc94444221f49f017R208
    resize: "none !important" as "none",
    overflow: "auto",
    "& textarea": {
      resize: "none !important" as "none",
    },
  },
  noIcon: {
    marginLeft: "14px",
  },
  gridPaddingOverRide: {
    padding: "0 15px",
  },
}));

export default useStyles;
